import { NgClass, SlicePipe } from '@angular/common';
import {
	ChangeDetectionStrategy,
	Component,
	input,
	ViewEncapsulation,
} from '@angular/core';

import { TranslatePipe } from '@ngx-translate/core';
import { AngularSvgIconModule } from 'angular-svg-icon';

import { SheetModule } from '@valk-nx/components/ui-sheet/src/lib/sheet.module';

@Component({
	changeDetection: ChangeDetectionStrategy.OnPush,
	encapsulation: ViewEncapsulation.None,
	imports: [
		AngularSvgIconModule,
		NgClass,
		SlicePipe,
		TranslatePipe,
		SheetModule,
	],
	selector: 'vp-list-grid',
	templateUrl: './list-grid.html',
})
export class ListGridComponent {
	name = input.required<string>();
	listItems = input.required<string[]>();

	sheetTitle = input<string>();
	title = input<string>();
	useCol2 = input<boolean>(true);
}
